import React, { useState, useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import MediaDialog, { IMediaDialogProps } from "./MediaDialog";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            "& img": {
                width: "100%",
            },
        },
    });
});

interface IImage {
    src: string;
    alt?: string;
}

interface IProps extends IMediaDialogProps {
    images: IImage[];
    initialImageIndex?: number;
}

export default function ImageDialog(props: IProps) {
    const classes = useStyles();
    const { images, initialImageIndex = 0, ...rest } = props;

    const [currentImage, setCurrentImage] = useState<IImage | undefined>();

    useEffect(() => {
        setCurrentImage(images[initialImageIndex % images.length]);
    }, [images, initialImageIndex]);

    if (typeof currentImage === "undefined") return null;

    return (
        <MediaDialog className={classes.root} {...rest}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <img src={currentImage.src} alt={currentImage.alt} />
            </div>
        </MediaDialog>
    );
}
